__turbopack_context__.v({
  "all-products-card": "ProductSection-module__GA2YEa__all-products-card",
  "all-products-desktop": "ProductSection-module__GA2YEa__all-products-desktop",
  "all-products-fallback": "ProductSection-module__GA2YEa__all-products-fallback",
  "bento-card": "ProductSection-module__GA2YEa__bento-card",
  "content": "ProductSection-module__GA2YEa__content",
  "content-container": "ProductSection-module__GA2YEa__content-container",
  "corporate-head": "ProductSection-module__GA2YEa__corporate-head",
  "image-container": "ProductSection-module__GA2YEa__image-container",
  "light": "ProductSection-module__GA2YEa__light",
  "m1": "ProductSection-module__GA2YEa__m1",
  "root": "ProductSection-module__GA2YEa__root",
  "single-card": "ProductSection-module__GA2YEa__single-card",
  "tag": "ProductSection-module__GA2YEa__tag",
});
